<form [formGroup]="form" *ngIf="form">
    <ion-row>
        <ion-col size="6">
            <ion-item>
                <ion-label position="stacked">Draw stage</ion-label>
                <ion-select interface="action-sheet" placeholder="Select Draw Stage" formControlName="drawStage">
                    <ion-select-option *ngFor="let ds of drawStages" [value]="ds.value">{{ds.name}}</ion-select-option>
                </ion-select>
            </ion-item>
        </ion-col>

        <ion-col size="6">
            <ion-item>
                <ion-label position="stacked">Round</ion-label>
                <ion-select interface="action-sheet" placeholder="Select Round" formControlName="round">
                    <ion-select-option *ngFor="let r of rounds" [value]="r.value">{{r.name}}</ion-select-option>
                </ion-select>
            </ion-item>
        </ion-col>
    </ion-row>
</form>